export const GET_USERS = "GET_USERS";
export const GET_EXT_USERS = "GET_EXT_USERS";
export const CHANGE_USER = "CHANGE_USER";
export const SET_USERS = "SET_USERS";
export const SET_EXT_USERS = "SET_EXT_USERS";
export const DELETE_USER = "DELETE_USER";
export const ADD_USER = "ADD_USER";
export const GET_EXT_USERS_RELS = "GET_EXT_USERS_RELS"
export const SET_EXT_USERS_RELS = "SET_EXT_USERS_RELS"
export const GET_USERS_LOGIN = "GET_USERS_LOGIN"
export const SET_USERS_LOGIN = "SET_USERS_LOGIN"
